import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerMessageListDataApi(data) {
  return request({
    url: "web/appConsumerMessage/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerMessageExportDataApi(data) {
  return request({
    url: "web/appConsumerMessage/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerMessageApi(data) {
  return request({
    url: "web/appConsumerMessage/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerMessageApi(data) {
  return request({
    url: "web/appConsumerMessage/init",
    method: "post",
    data
  });
}

// 根据条件查询条数
export function findAppConsumerMessageCountByConditionApi(data) {
  return request({
    url: "web/appConsumerMessage/findCountByCondition",
    method: "post",
    data
  });
}
